export { LandingPageTextAndMedia } from "./LandingPageTextAndMedia";
